import React from "react";
import * as LucideIcons from "lucide-react";

export type IconName = keyof typeof LucideIcons;

type IconProps = {
  name: IconName;
  className?: string;
};

const iconMap =
  LucideIcons as unknown as Record<
    string,
    React.ComponentType<React.SVGProps<SVGSVGElement>>
  >;

const Icon = ({ name, className }: IconProps) => {
  const LucideIcon = iconMap[name as string];

  if (!LucideIcon) {
    return null;
  }

  return <LucideIcon className={className} aria-hidden="true" />;
};

export default Icon;
